<!-- Define our page card. -->
<mat-card class="mat-page-card">

  <!-- Define the header of our page card. -->
  <mat-card-header>

    <!-- Give our page an icon. -->
    <mat-icon mat-card-avatar color="icon-orange">domain</mat-icon>

    <!-- Give our page a main title. -->
    <mat-card-title>
      Professional Employer Organization (PEO) Management
    </mat-card-title>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle>
      Below is a table of the existing PEOs in the system along with their management actions.
    </mat-card-subtitle>
  </mat-card-header>

  <!-- Define the content of our page card. -->
  <mat-card-content>
    <div>

      <div class="table-controls">

        <!-- Table Filter -->
        <mat-form-field>
          <mat-label>Search the table below</mat-label>
          <input matInput [(ngModel)]="filterInput" (keyup)="filterTable($event)" placeholder="Vensure" type="text">

          <button *ngIf="filterInput" mat-icon-button matSuffix matTooltip="Clear table filter."
                  aria-label="Clear PEO table filter." (click)="clearFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- Paginator -->
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 75, 100, 250, 500, 1000, 5000, 10000]"
                       aria-label="Select page size of PEO table."></mat-paginator>
      </div>

      <table mat-table matSort [dataSource]="peoDataSource" class="mat-elevation-z8">
        <!-- PEO ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Peo ID</th>
          <td mat-cell *matCellDef="let element;">
            <span>{{ element.peoId.replace('-', '*') }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Created Column -->
        <ng-container matColumnDef="created">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let element;">{{ element.created | date: 'medium' }}</td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Modified Column -->
        <ng-container matColumnDef="modified">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Modified</th>
          <td mat-cell *matCellDef="let element;">{{ element.updated | date: 'medium' }}</td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="_actions">

          <th mat-header-cell *matHeaderCellDef class="align-end">

            <!-- Test All API Credentials -->
            <a *ngIf="!filterInput" mat-icon-button aria-label="Button to test all API credentials." color="icon-orange"
               matTooltip="View and test PrismHR API credentials for all PEOs."
               routerLink="/admin/peo/api-credential-test"
               type="button">
              <mat-icon>vpn_key</mat-icon>
            </a>

            <!-- New PEO -->
            <button *ngIf="!filterInput" (click)="modifyPeo()" mat-icon-button aria-label="Button to add a new PEO."
                    color="icon-green"
                    matTooltip="Add new PEO." type="button">
              <mat-icon>add</mat-icon>
            </button>

            <!-- All client-customer mappings -->
            <a *ngIf="!filterInput" mat-icon-button aria-label="Button to view all PEO Client-Customer mappings."
               color="icon-blue"
               matTooltip="View all PEO Client-Customer Mappings."
               href="/admin/peo/client"
               type="button">
              <mat-icon>group</mat-icon>
            </a>
          </th>
          <td mat-cell *matCellDef="let element" class="align-end">

            <!-- Api Credentials -->
            <button mat-icon-button (click)="manageCredentials(element.peoId)"
                    aria-label="Button to view, modify or test the API credentials." color="icon-slate"
                    matTooltip="View, test or modify PrismHR API Credentials for PEO."
                    type="button">
              <mat-icon>vpn_key</mat-icon>
            </button>

            <!-- Edit PEO -->
            <button mat-icon-button (click)="modifyPeo(element)" aria-label="Button to edit PEO." color="icon-slate"
                    matTooltip="Modify PEO Record."
                    type="button">
              <mat-icon>edit</mat-icon>
            </button>

            <!-- Client-Customer Mappings -->
            <a mat-icon-button aria-label="Button to view Client-Customer mappings for PEO." color="icon-slate"
               matTooltip="View Client-Customer Mappings for PEO." href="/admin/peo/{{ element.peoId }}/client"
               type="button">
              <mat-icon>group</mat-icon>
            </a>
          </td>
          <td mat-footer-cell *matFooterCellDef class="align-end">&nbsp;</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" *ngIf="!!filterInput && !loading" colspan="5" style="text-align: center;">No PEOs found
            matching "{{ filterInput }}".
          </td>
          <td class="mat-cell" *ngIf="loading" colspan="5">
            <span style="display: flex; justify-content: center; align-items: center; width: 100%;">
              <mat-spinner color="warn" diameter="20"></mat-spinner>
              &nbsp;
              Loading
            </span>
          </td>
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
